import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rules-unauth',
  templateUrl: './rules-unauth.component.html',
  styleUrls: ['./rules-unauth.component.less']
})
export class RulesUnauthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/rules-unauth/rules-unauth.component.ts